var _radialGradient, _radialGradient2, _linearGradient, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirefoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2063.2 2129.5",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__a",
    cx: -14551.176,
    cy: 10389.188,
    fx: -14579.935,
    gradientTransform: "matrix(1.649 .07358 .1082 -2.4238 24836.559 26784.45)",
    gradientUnits: "userSpaceOnUse",
    r: 450.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#e0255a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#cc2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__b",
    cx: 683.058,
    cy: 1904.868,
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    r: 969.256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ccda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#007af9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0060e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#005fe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#2639ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#401e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4a1475"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__c",
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    x1: 560.589,
    x2: 369.151,
    y1: 1368.807,
    y2: 1995.035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000f43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#001962",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__d",
    cx: -8279.81,
    cy: 8546.382,
    gradientTransform: "matrix(2.638 .2619 .2619 -2.638 21352.88 25808.55)",
    gradientUnits: "userSpaceOnUse",
    r: 266.886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__e",
    cx: -8303.956,
    cy: 8802.293,
    gradientTransform: "matrix(2.638 .2619 .2619 -2.638 21352.88 25808.55)",
    gradientUnits: "userSpaceOnUse",
    r: 445.678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#ffaf0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ff7a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#ff4e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#ff2c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#ff1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#ff0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0039"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__f",
    cx: -8240.92,
    cy: 8389.157,
    gradientTransform: "matrix(2.638 .2619 .2619 -2.638 21352.88 25808.55)",
    gradientUnits: "userSpaceOnUse",
    r: 408.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#620700"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__g",
    cx: 735.129,
    cy: 1703.96,
    fx: 763.107,
    fy: 1690.131,
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    r: 782.18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#f92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#e91c45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#cf0e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#b5007f"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox-icon_svg__h",
    cx: 676.279,
    cy: 2096.712,
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    r: 923.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#ff6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#ff4a1d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__i",
    gradientTransform: "matrix(2.638 .2619 .2619 -2.638 21352.88 25808.55)",
    gradientUnits: "userSpaceOnUse",
    x1: -8931.212,
    x2: -8646.851,
    y1: 8580.821,
    y2: 8653.306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#ff2c2c",
    stopOpacity: 0.513
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#ff7a1a",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#ffb20d",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#ffd605",
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe302"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__j",
    gradientTransform: "matrix(2.1533 .2161 .2161 -2.1533 -801.401 7337.61)",
    gradientUnits: "userSpaceOnUse",
    x1: 198.14,
    x2: 143.568,
    y1: 3168.375,
    y2: 3308.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__k",
    gradientTransform: "matrix(2.1533 .2161 .2161 -2.1533 233.99 3966.17)",
    gradientUnits: "userSpaceOnUse",
    x1: -24.333,
    x2: 69.775,
    y1: 1368.03,
    y2: 1261.143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff272d",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__l",
    gradientTransform: "matrix(2.1533 .2161 .2161 -2.1533 233.99 3966.17)",
    gradientUnits: "userSpaceOnUse",
    x1: 153.605,
    x2: 153.672,
    y1: 1181.938,
    y2: 1256.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#c42482",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#c42482",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#c42482",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#c42482",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#c42482",
    stopOpacity: 0.091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#c42482",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__m",
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    x1: 640.471,
    x2: 946.126,
    y1: 2061.881,
    y2: 1378.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#ffee4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#ffe643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#ffd834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#ffc41e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#ffab02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#ffa900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9100"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox-icon_svg__n",
    gradientTransform: "matrix(2.1641 0 0 -2.1641 -43.151 4540.243)",
    gradientUnits: "userSpaceOnUse",
    x1: 700.825,
    x2: 556.038,
    y1: 1668.791,
    y2: 1280.041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ff8e00",
    stopOpacity: 0.858
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#ff8e00",
    stopOpacity: 0.729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff8e00",
    stopOpacity: 0.628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#ff8e00",
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#ff8e00",
    stopOpacity: 0.514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#ff8e00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#ff8e00",
    stopOpacity: 0.478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#ff8e00",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#ff8e00",
    stopOpacity: 0.314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#ff8e00",
    stopOpacity: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e00",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1667 198.1c-51.8 60.3-76 196.2-23.4 333.8 52.5 137.7 133.1 107.8 183.3 248.2 66.3 185.2 35.4 434.1 35.4 434.1s79.7 230.7 135.2-14.4C2120.3 739.6 1667 311.5 1667 198.1z",
    fill: "url(#firefox-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.6 2109.2c530.7 0 960.6-432.3 960.6-965.2s-429.9-965.2-960.1-965.2S75 611 75 1144c-1 533.5 429.4 965.2 959.6 965.2z",
    fill: "url(#firefox-icon_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.4 1739.1c-20.8 14.7-42.6 27.8-65.2 39.3 30-43.9 57.7-89.4 82.9-136.3 20.5-22.7 39.2-44.7 54.5-68.5 7.4-11.7 15.8-26.1 24.7-42.9 53.9-97.2 113.4-254.4 115.1-415.9v-.4c0-4 .1-8 0-11.9.3-40.5-3.9-81-12.4-120.6l1.2 9.3c-.5-2.4-.9-4.8-1.4-7.2.8 4.4 1.4 8.7 2.1 12.9 11 93.5 3.2 184.8-36.1 252-.6 1-1.3 1.9-1.9 2.9 20.4-102.2 27.2-215.1 4.5-328.1 0 0-9.1-54.9-76.6-221.7C1807 606 1738 527.3 1677 470c-53.4-66.1-102-110.5-128.7-138.6-55.9-58.8-79.3-102.9-88.9-131.7-8.3-4.2-115-107.8-123.5-111.7-46.6 72.2-193 297.9-123.3 508.9 31.6 95.6 111.4 194.8 194.9 250.5 3.7 4.2 49.7 54.2 71.6 167 22.6 116.5 10.7 207.4-35.8 341.9-54.7 118-194.9 234.6-326.2 246.5-280.6 25.5-383.4-140.9-383.4-140.9 100.3 40.1 211.1 31.7 278.6-9.9 68-42 109.1-73.2 142.4-60.9 32.9 12.2 59.1-23.3 35.6-60.1-37.1-57.1-104.7-86.6-171.8-74.8-68 11.1-130.3 64.9-219.5 12.8-5.8-3.3-11.4-7-16.7-11-5.9-3.9 19.1 5.9 13.3 1.5-17.3-9.4-48-30-56-37.3-1.3-1.2 13.5 4.7 12.1 3.5-83.3-68.6-72.9-115-70.3-144.1 2.1-23.3 17.2-53.1 42.7-65.2 12.3 6.7 20 11.9 20 11.9s-5.3-10.7-8.1-16.4c1-.4 1.9-.3 2.9-.7 10.1 4.9 32.4 17.5 44.2 25.2 15.3 10.8 20.2 20.4 20.2 20.4s4-2.2 1-11.6c-1.1-3.9-5.7-16.1-20.9-28.5l.9.1c9.1 5.2 17.7 11.1 25.7 17.8 4.3-15.5 12-31.8 10.3-60.8-1-20.4-.6-25.7-4.2-33.6-3.2-6.8 1.8-9.4 7.4-2.4-1-5.5-2.6-10.9-4.8-16v-.5c7-24.3 147.7-87.6 157.9-95 16.8-11.9 30.9-27.2 41.4-45 7.8-12.5 13.7-30 15.1-56.5.8-19.1-8.1-31.9-150.4-46.8-38.9-3.8-61.7-32-74.7-58-2.4-5.6-4.8-10.7-7.2-15.8-2.3-5.9-4.2-12-5.5-18.2 23.3-66.8 62.3-123.3 119.8-166 3.1-2.9-12.5.7-9.4-2.1 3.7-3.3 27.5-12.9 32-15.1 5.5-2.6-23.5-14.9-49.2-11.9-26.1 2.9-31.7 6.1-45.6 12 5.8-5.8 24.2-13.3 19.9-13.3-28.2 4.3-63.1 20.7-93.1 39.2-.1-3.2.6-6.4 1.8-9.4-13.9 5.9-48.2 29.8-58.1 50.1.4-3.9.6-7.8.6-11.7-10.6 8.9-20.2 18.9-28.6 29.9l-.5.5c-80.8-32.6-152-34.7-212.2-20.1-13.2-13.2-19.6-3.6-49.6-69.4-2-4 1.6 3.9 0 0-4.9-12.8 3 17 0 0-50.4 39.8-116.7 84.8-148.5 116.6-.4 1.3 37.1-10.6 0 0-13 3.7-12.1 11.4-14.1 81.2-.5 5.3-.1 11.2-.5 16-25.4 32.4-42.7 59.8-49.3 74-32.9 56.7-69.1 145-104.2 284.7 15.5-37.9 34.1-74.4 55.8-109.1-29.2 74.2-57.4 190.6-63 369.9 7.1-37 16.1-73.6 27.1-109.6-6.9 148.8 18.8 297.3 75.2 435.1 20.2 49.4 53.6 124.3 110.4 206.5 178.6 187.9 430.5 304.9 709.5 304.9 291.6 0 553.2-127.4 732.9-329.8z",
    fill: "url(#firefox-icon_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1538.9 1875.6c352.5-40.8 508.5-404 308.1-411.2-181-5.7-475.1 430.5-308.1 411.2z",
    fill: "url(#firefox-icon_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.4 1390.3c242.5-141.1 179.3-446 179.3-446s-93.6 108.7-157.2 282c-62.8 171.6-167.9 249.2-22.1 164z",
    fill: "url(#firefox-icon_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.5 2056c338.1 107.9 628.7-158.5 449.6-247.4-162.9-80.2-610 196.4-449.6 247.4z",
    fill: "url(#firefox-icon_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1897.6 1519.7c8.2-11.6 19.3-48.8 29.2-65.4 59.7-96.4 60.1-173.2 60.1-174.9 36.1-180.1 32.8-253.6 10.6-389.6-17.9-109.5-95.9-266.4-163.5-341.9-69.7-77.8-20.6-52.5-88.1-109.3-59.1-65.6-116.5-130.5-147.7-156.6-225.7-188.7-220.6-228.8-216.3-235.6-.7.8-1.8 2-3.2 3.6-2.7-10.7-4.6-19.6-4.6-19.6s-123.4 123.4-149.3 328.9c-17 134.2 33.3 274.1 106 363.6 37.9 46.3 80.7 88.4 127.7 125.5v-.1c55 78.9 85.2 176.3 85.2 281.1 0 262.4-212.8 475.1-475.3 475.1-35.8 0-71.4-4-106.3-11.9-123.9-23.6-195.4-86.1-231.1-128.5-20.4-24.3-29.1-42-29.1-42 111 39.8 233.7 31.4 308.3-9.8 75.2-41.7 120.7-72.6 157.6-60.4 36.4 12.1 65.4-23.1 39.4-59.6-25.5-36.5-91.8-88.7-190.2-74.2-75.3 11-144.3 64.4-242.9 12.6-6.4-3.3-12.5-6.9-18.5-10.9-6.5-3.8 21.1 5.8 14.7 1.5-19.2-9.3-53.2-29.7-62-36.9-1.5-1.2 14.9 4.7 13.4 3.5-92.2-68.1-80.7-114-77.8-142.9 2.3-23.1 19.1-52.6 47.3-64.6 13.6 6.7 22.1 11.8 22.1 11.8s-5.8-10.6-9-16.3c1.1-.4 2.2-.3 3.2-.7 11.2 4.8 35.9 17.4 48.9 25 16.9 10.7 22.3 20.3 22.3 20.3s4.5-2.2 1.2-11.5c-1.2-3.8-6.3-16-23.1-28.3l1 .1c10 5.1 19.5 11 28.4 17.7 4.7-15.4 13.2-31.5 11.4-60.3-1.1-20.2-.6-25.5-4.6-33.3-3.6-6.7 2-9.3 8.2-2.4-1.1-5.5-2.8-10.8-5.3-15.9l.1-.5c7.7-24.1 163.5-86.8 174.8-94.2 18.3-11.5 33.9-26.7 45.8-44.6 8.7-12.4 15.2-29.7 16.8-56 .5-11.9-3.1-21.2-44.4-30.2-24.8-5.4-63.1-10.6-122.1-16.2-43.1-3.8-68.3-31.8-82.7-57.6-2.6-5.6-5.3-10.6-8-15.6-2.5-5.9-4.6-11.9-6.1-18.1C796 486 842.4 428.4 902.9 388.9c3.5-2.8-13.9.7-10.4-2.1 4-3.3 30.4-12.8 35.4-15 6.1-2.6-26.1-14.8-54.4-11.8-28.9 2.9-35 6-50.5 11.9 6.4-5.7 26.8-13.2 22-13.1-31.2 4.3-69.9 20.5-103 38.9-.1-3.2.6-6.4 2-9.3-15.4 5.9-53.3 29.6-64.3 49.7.5-3.8.7-7.7.6-11.6-11.6 8.7-22.2 18.6-31.6 29.6l-.6.5c-89.5-32.3-168.2-34.4-234.9-19.9-14.6-13.1-38-33-71.2-98.2-2.3-3.9-3.5 8.1-5.2 4.2-12.9-29.9-20.7-78.9-19.4-112.6 0 0-26.7 12.1-48.7 62.9-4.1 9.1-6.7 14.2-9.3 19.2-1.2 1.5 2.7-16.7 2.1-15.7-3.8 6.5-13.8 15.6-18.1 27.3-3 8.7-7.2 13.6-9.9 24.4l-.6 1c-.2-3.2.8-13.2.1-11.1-10.3 20.9-19.2 42.5-26.6 64.6-11.9 39.1-25.7 92.2-27.9 161.4-.5 5.2-.1 11.1-.5 15.8-28.1 32.1-47.3 59.3-54.5 73.4C87 709.3 46.9 796.9 8 935.4c17.3-37.8 38-74.1 61.8-108.2-32.3 73.5-63.5 189-69.8 366.9 7.8-36.8 17.9-73.1 30-108.7-5.6 118.6 8.2 265.6 83.2 431.5 44.5 97.6 147 295.7 397.4 450.3s85.2 63.4 231.6 110.9c10.8 3.9 21.8 7.8 33 11.5-3.4-1.4-6.8-2.9-10.2-4.4 97.5 29.2 198.6 44.1 300.4 44.1 379.1.3 490.9-151.9 490.9-151.9s-.4.3-1.1.8c5.3-5 10.5-10.3 15.5-15.7-59.8 56.5-196.3 60.2-247.4 56.2 87-25.6 144.3-47.2 255.7-89.9 13-4.8 26.4-10.3 40-16.5 1.5-.6 3-1.4 4.4-2 2.7-1.3 5.4-2.4 8.1-3.8a756.58 756.58 0 00152.1-95.2c111.9-89.4 136.2-176.5 149-233.9-1.8 5.5-7.3 18.3-11.2 26.7-28.8 61.6-92.7 99.5-162.1 131.9 33-43.3 63.6-88.4 91.7-135.1 22.6-22.4 29.7-57.6 46.6-81.2z",
    fill: "url(#firefox-icon_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.4 1733.4c45.6-50.3 86.6-107.8 117.6-173.1 79.9-167.9 203.3-447.1 106.1-738.6-76.9-230.4-182.4-356.4-316.3-479.5C1451.2 142.3 1390.4 53.1 1390.4 0c0 0-251.2 280.1-142.3 572.1s332.1 281.4 479.7 586.2c173.7 358.7-140.6 750.1-400.5 859.7 15.9-3.5 577.7-130.7 607.3-452-.6 5.9-13.3 94.7-173.2 167.4z",
    fill: "url(#firefox-icon_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.5 691.1c.9-19-9-31.7-165.9-46.4-64.6-6-89.3-65.6-96.8-90.8-23 59.7-32.4 122.2-27.3 198 3.5 49.6 36.8 102.8 52.7 134.1 0 0 3.5-4.6 5.2-6.3 30-31.2 155.7-78.8 167.5-85.6 12.9-8.2 62.5-44.4 64.6-103z",
    fill: "url(#firefox-icon_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 338.6c-2.3-3.9-3.5 8.1-5.2 4.2-12.9-29.9-20.7-78.3-18.9-112.6 0 0-26.7 12.1-48.7 62.9-4.1 9.1-6.7 14.2-9.3 19.2-1.2 1.5 2.7-16.7 2.1-15.7-3.8 6.5-13.8 15.6-18.1 26.8-3.6 9.2-7.2 14.1-10 25.5-.8 3.1.8-13.7.1-11.6-51.3 99.2-61.1 249.1-55.7 242.8 109.2-116.6 234.4-144.3 234.4-144.3-13.2-9.9-42.2-38.2-70.7-97.2z",
    fill: "url(#firefox-icon_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M757.1 1558.4c-150.9-64.4-322.4-155.3-316-361.7 8.8-271.8 253.5-218.1 253.5-218.1-9.2 2.2-33.9 19.8-42.7 38.6-9.2 23.4-26.1 76.3 25 131.8 80.3 87-164.9 206.4 213.5 431.9 9.6 5.1-88.6-3.2-133.3-22.5z",
    fill: "url(#firefox-icon_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5 1422.9c107 37.2 231.6 30.7 306.3-10.5 50-27.8 114-72.4 153.5-61.4-34.1-13.5-60-19.8-91.1-21.3-5.3 0-11.6-.1-17.4-.7-11.4 0-22.8.6-34.1 1.9-19.3 1.8-40.6 13.9-60 12-1-.1 18.8-8.2 17.2-7.8-10.3 2.1-21.5 2.6-33.3 4.1-7.5.8-14 1.8-21.4 2.1-222.9 18.9-411.2-120.8-411.2-120.8-16.1 53.9 71.7 160.7 191.5 202.4z",
    fill: "url(#firefox-icon_svg__l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1761 1734.8c225.4-221.3 339.5-490.3 291.2-792.1 0 0 19.3 154.7-53.8 313 35.1-154.5 39.2-346.5-54-545.3-124.4-265.4-329-405-407.2-463.3-118.3-88.3-167.4-178.1-168.3-196.7-35.4 72.4-142.3 320.7-11.5 534.5 122.6 200.3 315.7 259.8 450.8 443.5 249.1 338.6-47.2 706.4-47.2 706.4z",
    fill: "url(#firefox-icon_svg__m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.7 1159c-78.8-162.7-177.1-233.7-270.1-310.7 10.8 15.1 13.5 20.5 19.5 30.3 81.9 87.2 202.6 300.1 114.9 567.2-165 502.9-824.8 266.1-894 199.6 28 291 515.1 430.3 832.3 241.6 180.5-170.9 326.5-461.3 197.4-728z",
    fill: "url(#firefox-icon_svg__n)"
  })));
}

export default __webpack_public_path__ + "static/firefox-icon.512482d4.svg";
export { SvgFirefoxIcon as ReactComponent };